import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EstCambioProvAuto } from '../model/detalle-solicitud';

@Injectable({
  providedIn: 'root'
})
export class EstadosService {
  PATH_ESTADOS = '';
  constructor(private http: HttpClient) {
    this.PATH_ESTADOS = environment.API_BASE + '/Estado';
  }

  getTieneCambioAutomaticoDocout(idSolicitud: number, idDepartamento: number, idSerie: number,
    idEstado: number, idSituacion: number, idProveedor: number): Observable<boolean> {
    return this.http.get<boolean>(this.PATH_ESTADOS + '/TieneCambioAutomaticoDocout/' + idSolicitud + '/'
      + idDepartamento + '/' + idSerie + '/' + idEstado + '/' + idSituacion + '/' + idProveedor);
  }

  getObtenEstadoCambioAutomaticoDocout(idSolicitud: number, idDepartamento: number, idSerie: number, idEstado: number,
    idSituacion: number, idProveedor: number): Observable<EstCambioProvAuto> {
    return this.http.get<EstCambioProvAuto>(
      this.PATH_ESTADOS + '/ObtenEstadoCambioAutomaticoDocout/' + idSolicitud + '/' + idDepartamento + '/' + idSerie + '/' + idEstado
      + '/' + idSituacion + '/' + idProveedor);
  }

  getTieneCambioAutomaticoCliente(idSolicitud: number, idDepartamento: number, idSerie: number,
    idEstado: number, idSituacion: number, idProveedor: number): Observable<boolean> {
    return this.http.get<boolean>(this.PATH_ESTADOS + '/TieneCambioAutomaticoCliente/' + idSolicitud + '/'
      + idDepartamento + '/' + idSerie + '/' + idEstado + '/' + idSituacion + '/' + idProveedor);
  }

  getObtenEstadoCambioAutomaticoCliente(idSolicitud: number, idDepartamento: number, idSerie: number, idEstado: number,
    idSituacion: number, idProveedor: number): Observable<EstCambioProvAuto> {
    return this.http.get<EstCambioProvAuto>(
      this.PATH_ESTADOS + '/ObtenEstadoCambioAutomaticoCliente/' + idSolicitud + '/' + idDepartamento + '/' + idSerie + '/' + idEstado
      + '/' + idSituacion + '/' + idProveedor);
  }

  CrearTrazaCambioEstadoAutomaticoDocout(idSolicitud: number, idEstadoOriginal: number, idSituacionOriginal: number,
    idEstadoCambio: number, idSituacionCambio: number): Observable<boolean> {
    return this.http.post<boolean>(this.PATH_ESTADOS + '/CrearTrazaCambioEstadoAutomaticoDocout', {
      idSolicitud, idEstadoOriginal,
      idSituacionOriginal, idEstadoCambio, idSituacionCambio
    });
  }

  CrearTrazaCambioEstadoAutomaticoCliente(idSolicitud: number, idEstadoOriginal: number, idSituacionOriginal: number,
    idEstadoCambio: number, idSituacionCambio: number): Observable<boolean> {
    return this.http.post<boolean>(this.PATH_ESTADOS + '/CrearTrazaCambioEstadoAutomaticoCliente', {
      idSolicitud, idEstadoOriginal,
      idSituacionOriginal, idEstadoCambio, idSituacionCambio
    });
  }

}
